export default __webpack_public_path__ + "static/media/kl-10.db0baf62.png";